module.exports = __webpack_public_path__ + "img/56400.d0e597da.jpg";